/**
 * Бэкенд иногда отдаёт одну и ту же обработку несколько раз (один id).
 * Для ExtrudeGeometry повторяющиеся shape.holes ломают триангуляцию крышек
 * (верх/низ панели не рисуются, остаются только торцы).
 */
export const machiningDedupKey = (item) => {
    const id = item?.id;
    if (id != null && id !== "") {
        return `id:${id}`;
    }
    const face = item?.contour?.position || "";
    const x = Number(item?.center?.x);
    const y = Number(item?.center?.y);
    const r = Number(item?.radius);
    if (Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(r) && r > 0) {
        return `round:${face}:${x}:${y}:${r}`;
    }
    const contourId = item?.contour?.id;
    if (contourId != null && contourId !== "") {
        return `contour:${contourId}`;
    }
    const name = item?.name || item?.position || "";
    return `fallback:${name}:${face}`;
};

export const dedupeMachiningById = (items) => {
    const seen = new Set();
    const out = [];
    for (const item of items || []) {
        const key = machiningDedupKey(item);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(item);
    }
    return out;
};
